/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type KahootPhaseInput = {
    phase: KahootPhaseInput.phase;
};
export namespace KahootPhaseInput {
    export enum phase {
        LOBBY = 'lobby',
        REVEAL = 'reveal',
        LEADERBOARD = 'leaderboard',
        ENDED = 'ended',
    }
}

